export default {
  navigation: {
    next: "Susunod",
    back: "Bumalik",
    surveyNavigation: "Nabigasyon ng survey",
    workspace: {
      home: "Home",
      example: "Halimbawa"
    }
  }
}
